import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {AtualizarSenha} from '../../../models/atualizar-senha.interface';
import {UsuarioService} from '../../services/usuario/usuario.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Usuario} from '../../../models/usuario.interface';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit, OnDestroy {
  btnDesabilitado = true;

  idUsuario!: number;
  updatePasswordForm = new FormGroup({
    senhaNova: new FormControl('', Validators.required),
    verificar: new FormControl('', Validators.required),
    senhaAntiga: new FormControl('', Validators.required),
  });
  subscription = new Subscription();

  tema = '';
  constructor(
    private readonly service: UsuarioService,
    private readonly snackBar: MatSnackBar
  ) {
    const usr: Usuario = JSON.parse(window.localStorage.getItem('usuario'));
    this.tema = usr.temaModelo;
    this.subscription.add(
      service.usuarioTk.subscribe({
        next: usuarioStorage => {
          this.idUsuario = usuarioStorage.id;
        }
      })
    );
  }

  ngOnInit(): void {
    const usuario: Usuario = JSON.parse(window.localStorage.getItem('usuario'));
    this.idUsuario = usuario.id;
    this.listenerVerifyPassword();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  hanlderUpdatePassword() {
    const update: AtualizarSenha = {
      idUsuario: this.idUsuario,
      senhaNova: this.updatePasswordForm.get('verificar').value,
      senhaAntiga: this.updatePasswordForm.get('senhaAntiga').value
    };
    this.service.updatePassword(update).subscribe({
      next: () => {
        this.openSnackBar('Senha Alterada com sucesso');
      },
      error: err => {
        this.openSnackBar(err.error.menssagem, null, true);
      }
    });
  }

  listenerVerifyPassword() {
    this.subscription.add(
      this.updatePasswordForm.get('verificar')
        .valueChanges.pipe(debounceTime(400), distinctUntilChanged())
        .subscribe({
          next: senha => {
            this.btnDesabilitado = !(this.helperValidatePassword(this.updatePasswordForm.get('senhaNova').value) &&
              senha === this.updatePasswordForm.get('senhaNova').value);
          }
        })
    );
  }

  helperValidatePassword(password: string) {
    return password !== '' && password.length > 8;
  }

  openSnackBar(message: string, action?: string, isError?: boolean) {
    this.snackBar.open(message, action, {duration: 3000, panelClass: [isError ? 'snackbar-error' : 'snackbar-success']});
  }
}
